// NotationModal.jsx
import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col,
    Label,
    Input,
    FormFeedback
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const NotationModal = ({
    modal,
    toggle,
    onSubmit,
    studyLevels = [],
    //students = [],
    academicYears = [],
    currentStudentId = null, // ID de l'étudiant actuel
    isEdit = false
}) => {
    // Schema Yup pour la validation
    const validationSchema = Yup.object().shape({
        academic_year_id: Yup.string().required("Année académique obligatoire"),
        study_level_id: Yup.string().required("Niveau d'étude obligatoire"),
        

    });

    // Valeurs initiales du formulaire
    const initialValues = {
        academic_year_id: "",
        note: "",
        //branch_id: "",
        study_level_id: "",
        //student_id: currentStudentId || "",
        //amount: ""
    };

    return (
        <Modal isOpen={modal} toggle={toggle} backdrop="static">
            <ModalHeader toggle={toggle}>
                {isEdit ? "Modifier - Note" : "Nouvelle - Note"}
            </ModalHeader>
            <ModalBody>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values, actions) => {
                        onSubmit(values);
                        actions.setSubmitting(false);
                        //toggle(); // fermer le modal après soumission
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, validation, isSubmitting }) => (
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col className="col-12">
                                    {/* Année académique */}
                                    <div className="mb-3">
                                        <Label>Année académique</Label>
                                        <Input
                                            name="academic_year_id"
                                            type="select"
                                            value={values.academic_year_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            invalid={validation.academic_year_id && !!errors.academic_year_id}
                                        >
                                            <option value="">-- Sélectionner --</option>
                                            {(academicYears || []).map(c => (
                                                <option key={c.id} value={c.id}>{c.name}</option>
                                            ))}
                                        </Input>
                                        <FormFeedback>{errors.academic_year_id}</FormFeedback>
                                    </div>

                                    <div className="mb-3">
                                        <Label>Évaluation</Label>
                                        <Input
                                            name="evaluation_id"
                                            type="select"
                                            className="form-select"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={
                                                validation.values.evaluation_id || ""
                                            }
                                            invalid={
                                                validation.touched.evaluation_id && validation.errors.evaluation_id
                                                    ? true
                                                    : false
                                            }
                                        >
                                            <option value="">-- Sélectionner --</option>
                                                {evaluations.map((c) => (
                                                <option key={c.id} value={c.id}>{c.title}</option>
                                                ))}

                                        </Input>
                                        {validation.touched.evaluation_id && validation.errors.evaluation_id ? (
                                            <FormFeedback type="invalid">{validation.errors.evaluation_id}</FormFeedback>
                                        ) : null}
                                    </div>
                                    
                                    

                                    
                                    <div className="mb-3">
                                        <Label>Matière</Label>
                                        <Input
                                            name="course_component_id"
                                            type="select"
                                            className="form-select"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={
                                                validation.values.subject_id || ""
                                            }
                                            invalid={
                                                validation.touched.subject_id && validation.errors.subject_id
                                                    ? true
                                                    : false
                                            }
                                        >
                                            <option value="">-- Sélectionner --</option>
                                                {courseComponents.map((c) => (
                                                <option key={c.id} value={c.id}>{c.name}</option>
                                                ))}

                                        </Input>
                                        {validation.touched.subject_id && validation.errors.subject_id ? (
                                            <FormFeedback type="invalid">{validation.errors.subject_id}</FormFeedback>
                                        ) : null}
                                    </div>
                                    
                                    <div className="mb-3">
                                        <Label>Note</Label>
                                        <Input
                                            name="note"
                                            type="numeric"
                                            placeholder="Note"
                                            validate={{
                                                required: { value: true },
                                            }}
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.subject_id || ""}
                                            invalid={
                                                validation.touched.subject_id && validation.errors.subject_id ? true : false
                                            }
                                        />
                                        {validation.touched.subject_id && validation.errors.subject_id ? (
                                            <FormFeedback type="invalid">{validation.errors.subject_id}</FormFeedback>
                                        ) : null}
                                    </div>
     
                                    
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className="text-end">
                                        <Button color="primary" type="submit" disabled={isSubmitting}>
                                            {isEdit ? "Modifier" : "Valider"}
                                        </Button>
                                        <Button color="secondary" className="ms-2" onClick={toggle}>Annuler</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </ModalBody>
        </Modal>
    );
};

export default NotationModal;
